module.exports = __webpack_public_path__ + "images/backgrounds/mountain/small.3f7f26a9f34ef2f2e950.jpg";